import { z } from 'zod';
// Schema for the updateRecipeByText request
export const UpdateRecipeByTextRequestSchema = z.object({
    recipeName: z.string().describe('Nombre de la receta a actualizar, según lo indicado por el usuario.'),
    recipeId: z
        .string()
        .optional()
        .nullable()
        .describe('ID de la receta a actualizar. Usa este campo cuando tengas el ID de la receta disponible.'),
    changes: z.string().describe(`
        Texto largo en markdown que describe en detalle los cambios a realizar en la receta.

        Ejemplo:
        [cambios]
        - Añadir 100g de cebolla
        - Quitar el ingrediente 'ajo en polvo'
        - Cambiar la cantidad de 'patata' a 200g
        - Subir el precio de la 'patata' a 3€/kg
        ...
    `),
});
//# sourceMappingURL=UpdateRecipeByTextRequestSchema.js.map